/* eslint-disable radix */
/* eslint-disable arrow-body-style */
/* eslint-disable react/prop-types */
// @mui
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import { Box, Paper, Tooltip, Typography } from '@mui/material';
import '../../../app.css';
import dayjs from 'dayjs';

export default function Calendar({ date, setDate, setMonth, monthlyStat, runningTask }) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Paper className="timelineCalendar" sx={{ overflow: 'hidden' }}>
        <StaticDatePicker
          // mask='____/__/__'
          variant="static"
          orientation="portrait"
          value={date}
          disableFuture
          ToolbarComponent={(params) => <MyToolbar {...params} />}
          onChange={(newValue) => setDate(newValue)}
          onMonthChange={(month) => setMonth(month)}
          renderDay={(day, _value, DayComponentProps) => (
            <DayComponent
              day={day}
              monthlyStat={monthlyStat}
              runningTask={runningTask}
              DayComponentProps={DayComponentProps}
            />
          )}
        />
      </Paper>
    </LocalizationProvider>
  );
}

const MyToolbar = (props) => {
  return (
    <Box sx={{ my: 1, mx: 3 }}>
      <Typography variant="overline" sx={{ color: '#637381' }}>
        Select Date
      </Typography>
      <Typography variant="h4">{dayjs(props?.parsedValue)?.format('MMM DD, YYYY')}</Typography>
    </Box>
  );
};

const DayComponent = ({ day, monthlyStat, runningTask, DayComponentProps }) => {
  const result = monthlyStat.filter((data) => data?.Date === dayjs(day).format('YYYY-MM-DD'));
  const isRunning =
    runningTask && new Date(runningTask?.TimeTracker?.[0]?.startTime).toDateString() === new Date(day).toDateString();
  if (!result?.[0]?.total_time && !isRunning) return <PickersDay {...DayComponentProps} />;
  let totalTime = parseInt(result?.[0]?.total_time) || 0;
  if (isRunning) totalTime += (new Date() - new Date(runningTask?.TimeTracker?.[0]?.startTime)) / 1000;
  const totalHour = Math.floor(totalTime / (60 * 60));
  const totalMinute = Math.floor((totalTime % (60 * 60)) / 60);
  const workPercentage = (totalTime / (8 * 60 * 60)) * 100;
  return (
    <Tooltip title={`${totalHour}h ${totalMinute}m`} placement="top" arrow>
      <div
        style={{
          background: '#ccff90',
          width: '36px',
          height: '36px',
          borderRadius: '50%',
          position: 'relative',
          marginRight: '1.5px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <PickersDay
          {...DayComponentProps}
          sx={{
            zIndex: 1,
            opacity: 1,
            bgcolor: 'transparent',
            position: 'absolute',
            color: 'black',
          }}
        />
        <div
          style={{
            position: 'absolute',
            width: '36px',
            top: '0',
            left: '0',
            height: `${100 - workPercentage}%`,
            background: 'white',
          }}
        />
      </div>
    </Tooltip>
  );
};
